// test1668
(1668 && 0);
